import { render, staticRenderFns } from "./CardsCard.vue?vue&type=template&id=40972e56&scoped=true&lang=pug&"
import script from "./CardsCard.vue?vue&type=script&lang=ts&"
export * from "./CardsCard.vue?vue&type=script&lang=ts&"
import style0 from "./CardsCard.vue?vue&type=style&index=0&id=40972e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40972e56",
  null
  
)

export default component.exports